import { render, staticRenderFns } from "./SamPagination.vue?vue&type=template&id=2fd24a88&scoped=true&shadow"
import script from "./SamPagination.vue?vue&type=script&lang=js&shadow"
export * from "./SamPagination.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamPagination.vue?vue&type=style&index=0&id=2fd24a88&prod&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2fd24a88",
  null
  ,true
)

export default component.exports